<template>
  <layout-no-menu>
    <!-- <ion-page class="ion-page" main> -->
    <ion-header>
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-icon name="arrow-round-back" size="large" @click="$router.go(-1)"></ion-icon>
        </ion-buttons>

        <ion-title>Player Edit</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-avatar style="margin: 15px auto; width: 100px; height: 100px">
        <img :src="player.avatar ? player.avatar : '/images/avatars/agent.png'" />
      </ion-avatar>
      <div style="text-align: center; margin-bottom: 10px">
        <ion-button size="small" @click="openAvatarEdit()">
          Edit Avatar
        </ion-button>
      </div>
      <ion-list>
        <ion-item>
          <ion-label position="stacked">First Name</ion-label>
          <ion-input :value="player.firstName" @input="player.firstName = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Last Name</ion-label>
          <ion-input :value="player.lastName" @input="player.lastName = $event.target.value"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label position="stacked">Avatar</ion-label>
          <ion-input :value="player.avatar" @input="player.avatar = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Gamer ID</ion-label>
          <ion-input :value="player.gamerId" @input="player.gamerId = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Team</ion-label>
          <ion-input :value="player.team" @input="player.team = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Grade</ion-label>
          <ion-input :value="player.grade" @input="player.grade = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Rating</ion-label>
          <ion-input :value="player.rating" @input="player.rating = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Division</ion-label>
          <ion-input :value="player.division" @input="player.division = $event.target.value"></ion-input>
        </ion-item>

        <ion-item>
          <ion-label>IsPresent</ion-label>

          <ion-checkbox slot="start" :checked="player.isPresent"
            @ionChange="player.isPresent = $event.target.checked == true"></ion-checkbox>
        </ion-item>

        <ion-item>
          <ion-label text-wrap>Paid
            <p v-if="onlinePaid">Paid online via {{ player.paymentType }}. Use Refund to reverse it.</p>
            <p v-else-if="player.paid && player.paymentType">Marked paid ({{ player.paymentType }}).</p>
          </ion-label>
          <ion-checkbox slot="start" :checked="player.paid" :disabled="onlinePaid"
            @ionChange="player.paid = $event.target.checked == true"></ion-checkbox>
        </ion-item>
        <ion-item v-if="order">
          <ion-label text-wrap>
            <h3>Order #{{ order.id }} · {{ order.status }}</h3>
            <p>{{ money(order.amountCents) }} via {{ order.provider }}<span v-if="order.paidDate"> on {{ formatDate(order.paidDate) }}</span>
              <span v-if="order.refundedCents"> · refunded {{ money(order.refundedCents) }}</span></p>
            <p v-if="order.items && order.items.length > 1">Covers {{ order.items.length }} players; a refund reverses the whole order.</p>
          </ion-label>
          <ion-button slot="end" color="danger" fill="outline" size="small" v-if="canRefund" :disabled="refunding"
            @click="refundOrder()">{{ refunding ? 'Refunding…' : 'Refund' }}</ion-button>
        </ion-item>
        <!-- <ion-item>
          <ion-label>Allow SMS Notifications</ion-label>
          <ion-checkbox
            slot="start"
            :checked="player.allowNotifications"
            @ionChange="player.allowNotifications = ($event.target.checked == true);"
          ></ion-checkbox>
        </ion-item>-->
        <!-- <ion-item>
          <ion-label position="stacked">Parent's Name</ion-label>
          <ion-input :value="player.parentName" @input="player.parentName = $event.target.value"></ion-input>
        </ion-item>-->
        <ion-item>
          <ion-label position="stacked">Email</ion-label>
          <ion-input :value="player.email" @input="player.email = $event.target.value"></ion-input>
        </ion-item>
        <ion-item>
          <ion-label position="stacked">Gender</ion-label>
          <ion-input :value="player.gender" @input="player.gender = $event.target.value"></ion-input>
        </ion-item>
        <!-- <ion-item>
          <ion-label position="stacked">Phone Number</ion-label>
          <ion-input :value="player.parentPhone" @input="player.parentPhone = $event.target.value"></ion-input>
        </ion-item>-->
      </ion-list>
      <section>
        <ion-button expand="block" v-on:click="save()">Save</ion-button>
        <hr />
        <ion-button expand="block" color="light" v-on:click="back()">Cancel</ion-button>
        <hr />
        <ion-button color="danger" v-on:click="deletePlayer()">Delete</ion-button>
        <!-- <ion-button @click="presentAlertConfirm">Show Alert (confirm)</ion-button> -->
        <!-- <ion-button color="danger">Delete</ion-button> -->
      </section>
      <div style="color: red">{{ error }}</div>
    </ion-content>
    <!-- </ion-page> -->
  </layout-no-menu>
</template>

<script>
import fetch from "@/services/fetch";
import PaymentAPI from "@/services/PaymentAPI";
const paymentAPI = new PaymentAPI();

export default {
  name: "home",
  components: {},
  data() {
    var tournamentId = this.$route.params.tournament;
    var playerId = this.$route.params.id;
    return {
      playerId: playerId,
      tournamentId: tournamentId,
      order: null,
      refunding: false,
      player: {
        tournamentId: tournamentId,
        rating: 1000,
        allowNotifications: true,
        division: 1,
        team: "",
        isPresent: true,
        gender: ""
      },
      error: "",
    };
  },
  computed: {
    onlinePaid() {
      return this.player.paid && (this.player.paymentType === "Stripe" || this.player.paymentType === "Square");
    },
    canRefund() {
      return this.order && (this.order.status === "Paid" || this.order.status === "PartiallyRefunded");
    },
  },
  methods: {
    back() {
      this.$router.back();
    },
    money(cents) {
      return PaymentAPI.money(cents);
    },
    formatDate(date) {
      const d = new Date(date);
      return Number.isNaN(d.getTime()) ? "" : d.toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
    },
    async loadOrder() {
      this.order = null;
      if (!this.player.paymentId) return;
      try {
        this.order = await paymentAPI.order(this.player.paymentId);
      } catch (e) {
        console.warn("order not available", e);
      }
    },
    async refundOrder() {
      if (!this.order) return;
      try {
        await this.$confirm(`Refund ${this.money(this.order.amountCents - this.order.refundedCents)} to the buyer? The players on this order will be marked unpaid.`);
      } catch (e) {
        return;
      }
      this.refunding = true;
      this.error = "";
      try {
        await paymentAPI.refund(this.order.id);
        this.loadData();
      } catch (e) {
        this.error = "Refund failed: " + (typeof e === "string" ? e : "");
      } finally {
        this.refunding = false;
      }
    },
    openAvatarEdit() {
      if (!this.playerId) return;
      this.$router.push({
        name: "AvatarEdit",
        params: { id: this.playerId, tournament: this.tournamentId },
      });
    },
    save() {
      this.error = "";
      let tournamentId = this.tournamentId;
      //let redirect = this.redirect;
      var playerId = this.playerId;
      var player = this.player;

      //validation
      let errors = [];
      if (!player.firstName) errors.push("first name is required.");
      //if (!player.team) errors.push("team is required.");
      //if (!player.grade) errors.push("grade is required.");
      //if (isNaN(player.grade)) errors.push("grade is not a number.");
      if (!player.rating) player.rating = 1000;
      player.rating = parseInt(player.rating) || 1000;
      if (isNaN(player.rating)) errors.push("rating is not a number.");
      if (!player.division) player.division = 1;
      player.division = parseInt(player.division) || 1;
      if (isNaN(player.division)) errors.push("division is not a number.");
      if (errors.length > 0) {
        this.error = errors;
        return;
      }

      if (playerId) {
        fetch
          .put(`player/${playerId}`, player)
          .then((response) => {
            console.log(response);
            //back
            this.$router.back();
            //if (redirect) {
            //   this.$router.push({ path: redirect });
            // } else {
            //    this.$router.push({ path: `/${tournamentId}/Player/${playerId}` });
            // }
          })
          .catch((e) => {
            this.error = "Error: Save failed." + e;
            console.warn(e);
          });
      } else {
        player.tournamentId = tournamentId;
        fetch
          .post(`player`, player)
          .then((response) => {
            console.log(response);
            //back
            this.$router.back();
          })
          .catch((e) => {
            this.error = "Error: Save failed." + e;
            console.warn(e);
          });
      }
    },
    deletePlayer() {
      let playerId = this.playerId;
      let tournamentId = this.tournamentId;
      if (playerId) {
        fetch
          .delete(`player/${playerId}`)
          .then((response) => {
            console.log(response);
            //back
            //this.$router.back();
            this.$router.push({
              name: "Players",
              params: { tournament: tournamentId },
            });
          })
          .catch((e) => {
            this.error = "Error: Delete failed";
            console.warn(e);
          });
      }
    },
    loadData() {
      var playerId = this.playerId;
      if (playerId) {
        fetch
          .get(`player/${playerId}`)
          .then((response) => {
            this.player = response.data;
            this.loadOrder();
          })
          .catch((e) => {
            this.error = "Error: Load failed";
            console.warn(e);
          });
      }
    },
  },
  created() {
    this.loadData();
  },
};
</script>
